export default "__VITE_ASSET__fwss4uBx__"